<template>
  <div>
    <div
      :class="{'has-padding': isShowFooter && !showingTypeAnswerInput
        && !presentation.isReactionEnabled && !isPickAnswerAndPickImage}"
    >
      <div v-if="!showingTypeAnswerInput">
        <div
          v-if="slide.multipleChoice
            && slide.SlideOptions.length > 1
            && slide.type != 'pickAnswer'"
          class="sub-header"
        >
          {{ $t("multipleChoiceInstruction") }} {{ slide.limitChoice }} {{ $t("options") }}.
        </div>

        <div
          v-if="slide.multipleChoice
            && slide.SlideOptions.length > 1
            && !slide.isCorrectGetPoint
            && slide.type == 'pickAnswer'
            && slide.slideType !== 'correctOrder'"
          class="sub-header"
        >
          {{ $t("quizYouMustPickAll") }}
        </div>
        <div
          v-if="slide.multipleChoice
            && slide.SlideOptions.length > 1
            && slide.isCorrectGetPoint && slide.type == 'pickAnswer'
            && slide.slideType !== 'correctOrder'"
          class="sub-header"
        >
          {{ $t("mustNotPickIncorrectAnswer") }}
        </div>

        <div
          v-if="!slide.multipleChoice
            && slide.type == 'pickAnswer' && checkAnyCorrectAnswer() > 1"
          class="sub-header"
        >
          {{ $t("youCanPickAnyCorrectAnswer") }}
        </div>
      </div>
      <Masonry v-if="viewType === 'image'" masonry-id="slide-option-masonry">
        <MasonryItem
          v-for="slideOption in slideOptions"
          :key="slideOption.id"
        >
          <Option
            :id="slideOption.id"
            v-model="submittedAnswer"
            :data-id="slideOption.id"
            variant="image"
            :title="slideOption.title"
            :image="slideOption.imageCropped"
            :multiple-select="slide.multipleChoice"
            :correct="slideOption.correct"
            :disabled="(result.id && slide.quizStatus >= QuizStatuses.QUESTION_SCREEN) || isSubmitting"
            :show-result="canShowQuizResult"
            :show-number-of-same-answer="optionQuizResult !== null"
            :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
            :text-colour="slide.textColour"
            :is-waiting-quiz-result="isWaitingQuizResult"
            :base-colour="slide.baseColour"
            @handle-image-load="redrawMasonryById('slide-option-masonry')"
          />
        </MasonryItem>
      </Masonry>

      <template v-if="viewType === 'text'">
        <Option
          v-for="slideOption in slideOptions"
          :id="slideOption.id"
          :key="slideOption.id"
          v-model="submittedAnswer"
          :data-id="slideOption.id"
          :base-colour="slide.baseColour"
          :text-colour="slide.textColour"
          variant="text"
          :title="slideOption.title"
          :image="slideOption.imageCropped"
          :multiple-select="slide.multipleChoice"
          :correct="slideOption.correct"
          :disabled="(result.id && slide.quizStatus >= QuizStatuses.QUESTION_SCREEN) || isSubmitting"
          :show-result="canShowQuizResult"
          :show-number-of-same-answer="optionQuizResult !== null && !enableForBigEvent"
          :is-waiting-quiz-result="isWaitingQuizResult"
          :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
        />
      </template>

      <CorrectOrderContent
        v-if="viewType === 'correctOrder'"
        :result="result"
        :is-quiz-submitted="isAnswerSubmitted"
        :is-waiting-quiz-result="isWaitingQuizResult"
        @updateCorrectOrderAnswer="updateCorrectOrderAnswer"
      />
      <MatchPairsContent
        v-if="viewType === 'matchPairs'"
        :result="result"
        :is-form-submitted="isAnswerSubmitted"
        :is-waiting-quiz-result="isWaitingQuizResult"
      />

      <CategoriseContent
        v-if="viewType === 'categorise'"
        :result="result"
        :is-form-submitted="isAnswerSubmitted"
        :is-waiting-quiz-result="isWaitingQuizResult"
      />
      <div v-if="showingTypeAnswerInput">
        <TypeAnswerQuizInput
          v-if="!isEmptyTypeAnswerAfterTimesUp"
          v-model="typeAnswerValue"
          :is-waiting-quiz-result="isWaitingQuizResult"
          class="type-answer-input"
          :type="typeAnswerResultType"
          :display-user-count="!!optionQuizResult"
          :number-of-user-with-same-answer="optionQuizResult &&
            optionQuizResult[typeAnswerValue.toLowerCase()]"
          @enterKey="submit"
        />

        <div v-if="showingCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('correctAnswerTitle') }}
          </p>
          <TypeAnswerQuizInput
            v-if="correctTypeAnswer"
            class="type-answer-input show-correct-answer-input"
            type="showCorrectAnswer"
            :value="correctTypeAnswer"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[correctTypeAnswer.toLowerCase()]"
          />
          <p
            v-else
            class="type-answer-no-correct-answer"
          >
            {{ $t('noCorrectAnswer') }}
          </p>
        </div>
        <div v-if="showingOtherCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('alsoAccepted') }}
          </p>
          <TypeAnswerQuizInput
            v-for="item in slide.otherCorrectQuiz"
            :key="item.id"
            class="type-answer-input type-answer-input--others"
            type="showOtherCorrectAnswer"
            :value="item.title || ''"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[item.title && item.title.toLowerCase()]"
          />
        </div>
      </div>
    </div>

    <QuizFormSubmitButton
      v-if="canShowSubmitButton"
      :disabled="isDisabledSubmitButton"
      :time-answer="Number(result.timeAnswer)"
      :time-to-answer="Number(slide.timeToAnswer)"
      :is-form-submitted="isAnswerSubmitted"
      :is-waiting-quiz-result="isWaitingQuizResult"
      @submit="submit"
    />

    <div
      class="quiz-result"
    >
      <QuizResult
        v-if="canShowQuizResult && result && result.id"
        :class="{
          show: isShowFooter,
        }"
        :result="result"
        :teamPlay="teamPlay"
        :teamQuizResult="teamQuizResult"
        :isEnableStreakDetection="isEnableStreakDetection"
        :isEnableStreakBonus="isEnableStreakBonus"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
// event bus
import EventBus from '@/eventBus'

// configs
import Config from '@/config'

// utils
import utils from '@/util'

// storage
import storage from '@/services/storage'

// 3rd parties
import sentry from '@/3rd-parties/sentry'

import UserIsTypingMixin from '@/mixins/UserIsTypingMixin'
import PreloadImageMixin from '@/mixins/PreloadImageMixin.vue'

// components
import QuizStatuses from '@/constants/QuizStatuses'
import AnswersAPI from '@/api/answers'
import TypeAnswerQuizInput from './TypeAnswerQuizInput.vue'
import QuizFormSubmitButton from './QuizFormSubmitButton.vue'
import Option from './Option.vue'
import Masonry, { masonryMixin } from '../masonry/Masonry.vue'
import MasonryItem from '../masonry/MasonryItem.vue'
import MatchPairsContent from './MatchPairsContent.vue'
import CategoriseContent from './CategoriseContent.vue'
import CorrectOrderContent from './CorrectOrderContent.vue'
import QuizResult from './QuizResult.vue'

export default {
  components: {
    Option,
    Masonry,
    MasonryItem,
    TypeAnswerQuizInput,
    QuizFormSubmitButton,
    MatchPairsContent,
    CategoriseContent,
    CorrectOrderContent,
    QuizResult,
  },
  mixins: [masonryMixin, UserIsTypingMixin, PreloadImageMixin],
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowFooter: false,
      timeLeft: 0,
      submittedAnswer: null,
      typeAnswerValue: this.result.typeAnswer || '',
      correctTypeAnswer: '',
      optionQuizResult: null,
      teamQuizResult: {},
      correctOrderAnswer: null,
      isAnswerSubmitted: false,
      isSubmitting: false,
    }
  },

  computed: {
    ...mapGetters(['isWaitingQuizResult', 'canShowQuizResult']),
    ...mapGetters('featureToggles', [
      'canMergePickImageIntoPickAnswer',
      'enableForBigEvent',
    ]),
    ...mapGetters({
      slide: 'themeModule/activeActivityWithTheme',
    }),
    ...mapGetters('liveStatsV2', ['canUseLiveStatsForQuiz']),
    ...mapState({
      audienceId: (state) => state.audienceId,
      slideOptions: (state, getters) => {
        const slideOptions = getters.activeActivity.SlideOptions.filter((item) => {
          return item.title || item.image || item.imageCropped
        })

        if (state.presentation.areSlideOptionsShuffling) {
          return utils.shuffleArrayWithSeed(slideOptions, state.audienceId.charCodeAt(0))
        }

        return slideOptions
      },
      teamPlay: (state) => state.presentation.teamPlay,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      presentation: (state) => state.presentation,
      isEnableStreakDetection: (state) => state.presentation.isEnableStreakDetection,
      isEnableStreakBonus: (state) => state.presentation.isEnableStreakBonus,
    }),
    viewType() {
      // TODO: need to refactor for more meaningful name: e.g: quizType()
      const isPickImageType = this.canMergePickImageIntoPickAnswer ?
        this.slide.slideType === 'imageChoice' || !this.slide.slideType :
        this.slide.slideType === 'imageChoice'
      if (this.slide.type === 'pickAnswer' && isPickImageType) {
        try {
          if (this.slide.SlideOptions.length && this.slide.SlideOptions.some((item) => item.image || item.imageCropped)) {
            return 'image'
          }
          return 'text'
        } catch (error) {
          Sentry.captureException(error)
        }
        return 'image' // Quiz: image choice
      }
      if (this.slide.type === 'pickAnswer' && this.slide.slideType == null) {
        return 'text' // Quiz: pick answer
      }

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'matchPairs') {
        return 'matchPairs'
      }

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'categorise') {
        return 'categorise'
      }

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'correctOrder') {
        return 'correctOrder'
      }

      return 'type' // Quiz: type answer
    },

    showingTypeAnswerInput() {
      return this.viewType === 'type'
    },

    isStickySubmitButton() {
      return this.slide.type === 'pickAnswer' && (this.slide.slideType === 'typeAnswer' || this.slide.slideType === 'correctOrder')
    },

    showingCorrectTypeAnswerInput() {
      return this.result && !this.result.correct && this.canShowQuizResult
    },

    showingOtherCorrectTypeAnswerInput() {
      return this.result
        && this.canShowQuizResult
        && this.slide.otherCorrectQuiz
        && this.slide.otherCorrectQuiz.length
    },

    isEmptyTypeAnswerAfterTimesUp() {
      return this.canShowQuizResult && !this.typeAnswerValue
    },

    isDisabledSubmitButton() {
      if (this.result &&
        (this.result.timeAnswer === this.slide.timeToAnswer || this.result.timeout)) {
        return true
      }

      if (this.slide.slideType === 'correctOrder') {
        return false
      }

      if (this.slide.slideType === 'matchPairs') {
        return !this.slide.SlideOptions.some((item) => item.pairSelected)
      }

      if (this.slide.slideType === 'categorise') {
        if (!this.slide.categoriseAnswer) return true
        return !this.slide.categoriseAnswer.some((option) => option.answer !== '')
      }

      return !this.submittedAnswer && (
        !this.typeAnswerValue ||
        (this.typeAnswerValue && !this.typeAnswerValue.trim()))
    },

    canShowSubmitButton() {
      const isQuestionScreen = this.slide.quizStatus === QuizStatuses.QUESTION_SCREEN
        || this.slide.quizStatus === QuizStatuses.RESULT_SCREEN
      if (!this.presentation.manualRevealCorrectAnswers
        || this.presentation.audiencePacing) return isQuestionScreen
      const isResultScreen = this.slide.quizStatus === QuizStatuses.RESULT_SCREEN

      return isQuestionScreen || (isResultScreen && !this.slide.showCorrectOption)
    },
    canShowResultButton() {
      if (!this.teamPlay) {
        return this.result && (this.result.id || this.result.notPlay)
      }
      return this.teamQuizResult && this.teamQuizResult.loaded
    },
    isResultSceneHasResult() {
      return this.result && this.result.id && this.canShowQuizResult
    },
    typeAnswerResultType() {
      if (this.isAnswerSubmitted) return 'disabled'
      if (this.isResultSceneHasResult && this.result.correct) return 'correct'
      if (this.isResultSceneHasResult && !this.result.correct) return 'incorrect'
      return ''
    },
    isPickAnswerAndPickImage() {
      return this.slide.type === 'pickAnswer' && (this.slide.slideType === 'imageChoice' || !this.slide.slideType || this.slide.slideType === 'correctOrder')
    },
  },

  watch: {
    'slide.quizStatus': function changeStatus(quizStatus) {
      if (quizStatus === 5) {
        this.getQuizResult()
      }
    },
    'slide.showCorrectOption': function changeShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        this.getQuizResult()
      }
    },
  },

  created() {
    this.QuizStatuses = QuizStatuses
  },

  mounted() {
    setTimeout(() => {
      // Because <QuizForm> is placing inside <transition> component
      // and the Footer is position-fixed,
      // The footer is flicked when transiting to the question screen.
      // Delay showing the Footer will fix this issue.
      this.isShowFooter = true
    }, 300)
    // get correct type answer
    if (this.slide.slideType === 'typeAnswer') {
      if (this.slide.correctQuizTypeAnswer) {
        this.correctTypeAnswer = this.slide.correctQuizTypeAnswer
      } else if (
        this.slide.otherCorrectQuiz &&
        this.slide.otherCorrectQuiz.length
      ) {
        this.slide.otherCorrectQuiz.forEach((item) => {
          if (item.title && !this.correctTypeAnswer) {
            this.correctTypeAnswer = item.title
          }
        })
      }
    }

    if (this.result && this.result.id) {
      this.submittedAnswer = this.result.vote
      this.isAnswerSubmitted = true
    }

    if (this.slide.quizStatus === 5) {
      this.getQuizResult()
    }
  },
  destroyed() {
    this.isShowFooter = false
  },
  methods: {
    ...mapActions([
      'compareDataSlideV2Action',
    ]),
    _isValidPrompt(option) {
      return option.title || option.image
    },
    _isValidAnswer(option) {
      return option.pairTitle || option.pairImage
    },
    _isValidPair(option) {
      return this._isValidPrompt(option) && this._isValidAnswer(option)
    },
    getMatchPairsAnswer() {
      const answers = []
      this.slide.SlideOptions.forEach((option) => {
        if (this._isValidPair(option)) {
          answers.push({
            prompt: option.id,
            answer: option.pairSelected && option.pairSelected.id,
          })
        }
      })
      return answers
    },

    getCategoriseAnswer() {
      const options = this.slide.categoriseAnswer
      if (!options) return {}
      const categories = JSON.parse(this.slide.matchingQuestionOptions)
      const categoriseAnswer = categories.map((category) => ({
        id: category.id,
        value: category.value,
      }))

      options.forEach((option) => {
        const answerCategory = categoriseAnswer.find((category) => category.value === option.answer)
        if (!answerCategory) return
        answerCategory.options = answerCategory.options ? [...answerCategory.options, option.value] : [option.value]
      })

      return categoriseAnswer
    },

    updateCorrectOrderAnswer(answer) {
      this.correctOrderAnswer = answer
    },

    getCorrectOrderAnswer() {
      return this.correctOrderAnswer.map((item) => item.id)
    },

    async submit() {
      if (this.isAnswerSubmitted || this.isSubmitting) {
        return
      }

      this.isSubmitting = true
      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.error = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        presentationId: this.$store.state.presentation.id,
        slideId: this.slide.id,
        slide: this.slide.id,
        slideVersion: this.slide.version,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.slide.slideTimestamp,
        config: {
          timeToAnswer: this.slide.timeToAnswer,
          // quizTimestamp: this.slide.quizTimestamp, old code: linh vu sentry log
          // new code: hainh replace computed to global state
          quizTimestamp: this.slide.quizTimestamp,
          multipleChoice: this.slide.multipleChoice,
          isCorrectGetPoint: this.slide.isCorrectGetPoint,
          stopSubmission: this.slide.stopSubmission,
          fastAnswerGetMorePoint: this.slide.fastAnswerGetMorePoint,
          otherCorrectQuiz: this.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.slide.correctQuizTypeAnswer,
          quizToken: this.slide.quizToken,
          SlideOptions: this.slide.SlideOptions.map((option) => {
            return {
              id: option.id,
              correct: option.correct,
            }
          }),
          minPoint: this.slide.minPoint,
          maxPoint: this.slide.maxPoint,
        },
        type: this.slide.type,
        slideType: this.slide.slideType,
        streakRelatedInfo: {
          isEnableStreakDetection: this.isEnableStreakDetection,
          isEnableStreakBonus: this.isEnableStreakBonus,
          teamPlay: this.teamPlay,
        },
        isDisableEveryoneHasAnswered: this.presentation.isDisableEveryoneHasAnswered,
      }

      if (this.presentation.audiencePacing) {
        payload.config.audiencePacingTimeAnswer = utils.getTimeStamp() - this.slide.quizTimestamp
      }

      if (this.slide.slideType === 'typeAnswer') {
        payload.typeAnswer = this.typeAnswerValue
        if (!payload.typeAnswer.trim()) {
          return
        }
        payload.vote = []
      } else if (!this.slide.multipleChoice) {
        payload.vote = [this.submittedAnswer]
      } else {
        payload.vote = this.submittedAnswer
      }

      if (this.slide.slideType === 'matchPairs') {
        payload.vote = []
        payload.pairs = this.getMatchPairsAnswer()
      }

      if (this.slide.slideType === 'categorise') {
        payload.vote = []
        payload.categories = this.getCategoriseAnswer()
      }

      if (this.slide.slideType === 'correctOrder') {
        payload.vote = []
        payload.pairs = this.getCorrectOrderAnswer()
      }

      payload.audienceName = this.$store.state.audienceName
      payload.audienceEmoji = this.$store.state.audienceEmoji
      EventBus.$emit('quiz-stop-submit')
      EventBus.$emit('stop-progress-bar-quiz')
      EventBus.$emit('cancelAnimationFrame')

      if (this.$store.state.presentation.teamPlay) {
        payload.audienceTeam = this.$store.state.audienceQuizTeam
      }
      this.isAnswerSubmitted = true

      // Sẽ lưu lại flag này, tránh trường hợp slow internet dẫn tới chưa nhận được response api này mà lại nhận được socket timeup
      this.$store.state.isSlideAnswerSubmitting[this.slide.id] = true

      try {
        if (payload.type === 'pickAnswer') {
          if (!payload.config.quizTimestamp || payload.config.quizTimestamp.length === 0) {
            sentry.captureException('Invalid quizTimestamp', {
              extra: {
                file: 'QuizForm.vue',
                description: 'bo sung quiz timestamp vao data',
                payload,
                quizTimestamp: payload.config.quizTimestamp,
                slide: this.slide,
              },
            })
          }
        }
      } catch (error) {
        Sentry.captureException(error)
      }

      try {
        if (!payload.slide) return
        const res = this.slide.slideType === 'categorise' ?
          await AnswersAPI.createCategoriseAnswer(payload) :
          await AnswersAPI.createQuizAnswer(payload)
        console.log('resresres', res)
        this.$store.state.isSlideAnswerSubmitting[this.slide.id] = undefined
        res.id = 1
        res.timeAnswer = parseFloat(res.timeAnswer)
        this.timeLeft = this.slide.timeToAnswer - res.timeAnswer
        this.timeLeft = parseFloat(this.timeLeft)
        EventBus.$emit('quiz-waiting-result', {
          timeAnswer: res.timeAnswer,
          timeLeft: this.timeLeft,
          answer: res,
          notSubmit: true,
        })

        const presentationId = this.$store.state.presentation.id
        const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
        answeredSlideIds.push(this.slide.id)
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)
        if (this.presentation.audiencePacing) {
          window.setTimeout(() => {
            this.$store.dispatch('updateSlide', {
              quizStatus: QuizStatuses.RESULT_SCREEN,
            })
          }, 2e3)
        }
        if (res.tsRequest) {
          this.$store.state.tsRequest = res.tsRequest
        }
        utils.mixpanelTrack(
          'Audience > Quiz',
          'Submit answer',
          'Audience Submit Answer',
        )
      } catch (error) {
        this.$store.state.isSlideAnswerSubmitting[this.slide.id] = undefined

        if (error.body && error.errorCode === 411) {
          this.error = this.$t('submissionClosedButton')
        } else {
          this.error = this.$t('openendedSubmissionFail')
          let quizTimestamp = null
          if (payload.config) {
            quizTimestamp = payload.config.quizTimestamp
          }
          sentry.captureException('Error when creating answer', {
            extra: {
              file: 'QuizForm.vue',
              payload,
              payloadQuizTimestamp: quizTimestamp,
              slide: this.slide,
              errorMessage: error.message,
              stackTrace: error.stack,
              errorFull: error,
              errorCode: error.errorCode,
            },
          })
        }
        utils.mixpanelTrack(
          'Multiple Choice Submit',
          'Audience submit fail',
          JSON.stringify(error),
        )
      } finally {
        this.isSubmitting = false
        this.setUserTypingEnd()
      }

      // log data api new slide v2 compre with old api slide
      try {
        this.compareDataSlideV2Action()
      } catch {
        // do nothing
      }
    },
    getQuizResult() {
      if (this.presentation.manualRevealCorrectAnswers
        && !this.presentation.audiencePacing && !this.slide.showCorrectOption) return
      if (this.slide.quizResultCache) {
        this.$http.get(this.slide.quizResultCache).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      } else {
        this.$http.get(Config.api.slideQuizResult + this.slide.id, {
          params: {
            audiencePacing: this.presentation.audiencePacing,
          },
        }).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      }
    },
    lowerCaseOptionKey(options) {
      return Object.keys(options)
        .filter((k) => !!k)
        .map((k) => ({ [k.toLowerCase()]: options[k] }))
        .reduce((item, agg) => ({ ...item, ...agg }), {})
    },
    normalizeTeamQuizResult(teamQuizResult) {
      if (teamQuizResult) {
        this.teamQuizResult = teamQuizResult
        if (!Object.keys(teamQuizResult).length) {
          this.teamQuizResult.noData = true
        }
      } else {
        this.teamQuizResult.noData = true
      }
      this.teamQuizResult.loaded = true
    },
    checkAnyCorrectAnswer() {
      let count = 0
      if (!this.slide.SlideOptions) return count
      this.slide.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })
      return count
    },
  },

}
</script>

<style lang="scss" scoped>
.sub-header {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 16px 0 16px;
  opacity: 0.7;
}
.type-anwwer-correct-text {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
}

.type-answer-no-correct-answer {
  text-align: left;
}

.type-answer-input {
  margin-bottom: 28px;
  &--others {
    margin-bottom: 10px;
  }
}

.quiz-footer {
  display: none;
  width: 100%;
  z-index: 100;
  filter: drop-shadow(0 -4px 39px rgba(0,0,0,0.15));
  &.show {
    display: block;
  }
  &.sticky {
    transition: all 0.3s ease;
    position: fixed;
    bottom: 0;
    left: 0;
    padding-bottom: 40px;

    .quiz-footer--content {
      padding: 16px;
    }
  }
  &.type-answer__footer {
    margin-top: 32px;
  }
}

.quiz-footer--content {
  max-width: 710px;
  width: 100%;
  margin: 0 auto;
}

.has-padding {
  padding-bottom: 120px;
}
.animation-text {
  animation: show-height 1s;
  overflow: hidden;
}

@keyframes show-height {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 500px;
  }
}

.quiz-result {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;

  &-content {
    padding: 12px 16px;
  }
  filter: drop-shadow(0px -4px 14px rgba(0, 0, 0, 0.10));
}
</style>
